export const REGISTRANT_RECORD_ROLES = [
  "EventAdmins",
  "CheckInStaff",
  "MedicalProviders",
  "StationLeads",
  "CommunicationsTeam",
  "ReportingTeam",
  "Volunteers",
  "DistributionStaff",
];

export type StaffTab = "dashboard" | "registrants" | "checkin" | "stations" | "distribution" | "incidents";

const tabAccess: Record<StaffTab, string[]> = {
  dashboard: ["EventAdmins", "ReportingTeam", "CommunicationsTeam", "StationLeads"],
  registrants: REGISTRANT_RECORD_ROLES,
  checkin: ["EventAdmins", "CheckInStaff"],
  stations: ["EventAdmins", "MedicalProviders", "StationLeads"],
  distribution: ["EventAdmins", "DistributionStaff", "CheckInStaff"],
  incidents: ["EventAdmins", "CheckInStaff", "MedicalProviders", "StationLeads", "Volunteers", "DistributionStaff"],
};

const tabOrder: StaffTab[] = ["dashboard", "registrants", "checkin", "stations", "distribution", "incidents"];

export function allowedTabsForGroups(groups: string[]): StaffTab[] {
  return tabOrder.filter((tab) => groups.some((group) => tabAccess[tab].includes(group)));
}
